module.exports = __webpack_public_path__ + "img/hpEdu.bdbcedb3.png";